export default __webpack_public_path__ + "static/media/banner2.6cf672bb.jpg";